'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformOrigin = exports.transform = undefined;

var _templateObject = _taggedTemplateLiteral(['\n    ', ';\n  '], ['\n    ', ';\n  ']);

var _core = require('@emotion/core');

var _ = require('../../');

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var transform = exports.transform = function transform(_ref) {
  var transform = _ref.transform;
  return transform && (0, _core.css)(_templateObject, _2.default.responsive('transform')(transform));
};

var transformOrigin = exports.transformOrigin = function transformOrigin(_ref2) {
  var transformOrigin = _ref2.transformOrigin;
  return transformOrigin && (0, _core.css)(_templateObject, _2.default.responsive('transform-origin')(transformOrigin));
};